<template>
  <v-dialog width="800px"
            :value="value"
            persistent
            scrollable>
    <v-card class="kbLight">
      <v-toolbar class="kbLight" dark flat>
        <div class="text-h6 kbDarkBlueText--text">{{ $t('general.sendEmail') }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal()">
          <v-icon color="kbDarkBlueText">clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text v-if="emails.length === 0">
        <v-row>
          <v-col cols="12">
            <NotFound height="400px"
                      :message="$t('general.noEmailsConnected')">
            </NotFound>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text v-else>
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-select color="kbDarkBlueText"
                      :items="emails"
                      item-text="email"
                      item-value="email"
                      :label="$t('general.from')"
                      v-model="selectedEmail">
            </v-select>
          </v-col>

          <v-form lazy-validation
                  ref="emailComposer"
                  v-model="valid">
            <v-col cols="12" class="pb-0">
              <v-text-field color="kbDarkBlueText"
                            :label="$t('general.to')"
                            :readonly="!!selectedPersonEmail"
                            :rules="[rules.required, rules.email]"
                            v-model="toEmail">
              </v-text-field>
            </v-col>

            <v-col cols="12" class="pb-0">
              <v-text-field color="kbDarkBlueText"
                            :label="$t('general.subject')"
                            :rules="[rules.required]"
                            v-model="subject">
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <quill-editor :options="{ color: $vuetify.theme.isDark ? '#ffffff' : '#172B4D' }"
                            ref="editorEmail"
                            v-model="message"
                            @ready="updatePlaceholder">
              </quill-editor>
            </v-col>

            <v-col cols="12" class="text-center">
              <BtnCustomizeField color="kbPurple"
                                 :itemToCustomize="$t('general.message')"
                                 @customizeMessage="customizeMessage">
              </BtnCustomizeField>
            </v-col>
          </v-form>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="red"
               class="mr-2"
               outlined
               @click="$router.push('/settings/emails')"
               v-if="emails.length === 0">
          {{ $t('general.connectAccount') }}
        </v-btn>

        <v-btn color="red"
               class="mr-2"
               outlined
               @click="toggleModal()">
          {{ $t('general.cancel') }}
        </v-btn>

        <v-btn color="kbPink"
               dark
               :loading="loadingSubmit"
               @click="submit()"
               v-if="emails.length > 0">
          {{ $t('general.send') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnCustomizeField from '@/pages/App/Communications/CustomizeFields/BtnCustomizeField.vue'
import rules from '@/libs/rules'
import notifications from '@/libs/notifications'
import NotFound from '@/components/ui/NotFound'
import authService from '@/services/authService'
import oauth from '@/services/oauthService'
export default {
  components: { BtnCustomizeField, NotFound },
  computed: {
    editor () {
      return this.$refs.editorEmail.quill
    }
  },
  async created () {
    try {
      this.loading = true
      this.emails = await authService.getRegisteredEmails()

      if (this.emails.length > 0) {
        this.selectedEmail = this.emails[0]
      }
      this.loading = false

      if (this.selectedPersonEmail) {
        this.toEmail = this.selectedPersonEmail
      }
    } catch (e) {
      notifications.error(e.message)
      this.loading = false
    }
  },
  data: () => ({
    emails: [],
    loadingSubmit: false,
    message: '',
    rules,
    selectedEmail: '',
    caretPosition: 0,
    subject: '',
    toEmail: '',
    valid: true
  }),
  methods: {
    async submit () {
      try {
        if (!this.selectedEmail) return

        this.loadingSubmit = true

        const data = {
          message: this.message,
          from: this.selectedEmail.email,
          subject: this.subject,
          to: this.selectedPersonEmail
        }

        await oauth.sendMessage(data)
        notifications.success(this.$t('general.emailSuccessfullySent'))
        this.toggleModal()
      } catch (e) {
        notifications.error(e.message)
      } finally {
        this.loadingSubmit = false
      }
    },
    customizeMessage (item) {
      const selection = this.editor.getSelection(true)
      this.editor.insertText(selection.index, item.value)
    },
    toggleModal () {
      this.toEmail = ''
      this.subject = ''
      this.message = ''
      this.$emit('clear')
      this.$emit('input', false)
    },
    updatePlaceholder () {
      this.editor.root.setAttribute('data-placeholder', 'Write your email here')
    }
  },
  props: {
    selectedPersonEmail: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (value) {
      if (value && this.selectedPersonEmail) {
        this.toEmail = this.selectedPersonEmail
      }
    }
  }
}
</script>
